import { useState } from 'react';
import useStoreItemClick from 'src/modules/parkplusStoreV2/hooks/useStoreItemClick';
import { LayoutEntityType, LayoutPropType } from 'src/modules/parkplusStoreV2/types/layout';
import AnimatedImage from 'core-lib/components/AnimatedImage';
import { Typography } from 'ui-v2/components/Typography';
import VideoCarouselCard from '../../Cards/VideoCarouselCard';
import s from './VideoCarousel.module.scss';
import dynamic from 'next/dynamic';

const Swiper = dynamic(() => import('core-lib/components/Swiper'), {
  ssr: false,
});

export const VideoCarousel = ({ data }: LayoutPropType) => {
  const [activeIndex, setActiveIndex] = useState(1);
  const { handleItemClickWithDelegation } = useStoreItemClick();
  const CARDID = data.entityType || 'PRODUCT';
  const [swiperRender, setSwiperRender] = useState(null);
  const slideTo = index => swiperRender.slideTo(index);

  return (
    <div
      className={s.root}
      style={{
        background: data?.backgroundColor,
      }}
      onClick={e => {
        handleItemClickWithDelegation(
          e,
          CARDID,
          data?.entityType || LayoutEntityType.Product,
          data?.data,
          data?.title,
        );
      }}
    >
      <div className={s.textStack}>
        <Typography label={data?.title} variant="h_3_medium" style={{ color: data?.textColor }} />
        <AnimatedImage
          src="https://parkplus-bkt-img.parkplus.io/production/socialCommunity/public/streakBrokeStar_20240501125156634124.png"
          alt="streakBroke"
        />
      </div>

      <div className={s.videoCard}>
        <Swiper
          effect="creative"
          onSlideChange={el => {
            setActiveIndex(el.realIndex);
          }}
          creativeEffect={{
            prev: {
              translate: ['-100%', 0, 0],
              scale: 0.9,
            },
            next: {
              translate: ['100%', 0, 0],
              scale: 0.9,
            },
          }}
          slidesPerView={1.7}
          spaceBetween={20}
          centeredSlides
          initialSlide={1}
          loop={true}
          onSwiper={setSwiperRender}
          slides={data?.data?.map((item, id) => (
            <>
              <VideoCarouselCard
                key={`video-${id}`}
                data={item}
                showControls={true}
                isActive={activeIndex}
                idx={id}
                id={CARDID}
                onVideoEnd={() => {
                  slideTo(
                    swiperRender?.activeIndex + 1 < data?.data?.length
                      ? swiperRender?.activeIndex + 1
                      : 1,
                  );
                }}
              />
            </>
          ))}
        />
      </div>
    </div>
  );
};
